import React, {useEffect, useState} from 'react';
import {useQuery} from 'react-query'; 
import {GetCacheKey} from "../../../services/common/utils"; 
// import RoamingBanner from "../../../pages/roaming/roaming-banner";
import RoamingPacksBanner from "./roamingPacksBanner";
import RoamingPacksCountries from "./home";
import BottomBanners from "./BottomBanners";
import Loadingcomponent from '../../loader/loadingcomponent';
import PageShimmer from '../../loader/skeletons/common/page-shimmer';
function ViewPackshome() {

    const {
        data: {data}={}, 
        isLoading, 
        isFetching
    } = useQuery([GetCacheKey('roamingPacks'), '/v6/api/pms/getpagemodules', {"name":"rn_roaming_countries"}, {}]);

    if(isLoading || isFetching){
        return (<PageShimmer/>)
    }
    const getPageComponents = (pmsitem) => {
        switch (pmsitem?.templatetype) {
            case '103': {
                return <div className='sprint14-bg-transparent radius_section'><RoamingPacksCountries pmsitem={pmsitem} bgcolor={data?.bgcolor}/></div>
                break;
            }
            case "124": {
                return <RoamingPacksBanner pmsitem={pmsitem} />;
                break;
            }
            case "109":{
                return <BottomBanners pmsitem={pmsitem} />;
                break;
            }
            default: {
                return <></>
            }
        }
    }
    return (
        // isLoading || isFetching ? <Loadingcomponent/> :
        <div style={{background: data?.bgcolor}} className='pb-76'>
            {
              data?.data?.map(item => {
                    return (
                        <>{getPageComponents(item)}</> 
                    )
                }) 
            }           
        </div>
  )
}

export default ViewPackshome;